import React from "react";
import { Search } from "lucide-react";

import styles from "./DataTableSearch.module.css";

export const DataTableSearch = ({
  value = "",
  onChange,
  placeholder = "Search",
  maxWidth,
}) => {
  return (
    <div className={styles.searchWrapper} style={maxWidth ? { maxWidth } : undefined}>
      <Search size={18} className={styles.searchIcon} />
      <input
        type="search"
        className={styles.searchInput}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
      />
    </div>
  );
};
